import { ProCard, ProForm, ProFormText } from "@ant-design/pro-components";
import { message } from "antd";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { AntPageContainer } from "../../shared/components/AntPageContainer";
import authApi from "../api";
import { ChangePasswordRequest } from "../types";

interface ChangePasswordFormValues extends ChangePasswordRequest {
  confirmPassword: string;
}

export const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: ChangePasswordFormValues) => {
    try {
      const response = await authApi.changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      messageApi.success(response.message || "Password changed successfully");
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      if (err instanceof AxiosError && err.response?.status === 400) {
        messageApi.error(
          err.response?.data?.message || "Current password is incorrect"
        );
      } else {
        messageApi.error("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <AntPageContainer>
      {contextHolder}
      <ProCard
        title="Change Password"
        style={{ maxWidth: 600, margin: "0 auto" }}
      >
        <ProForm<ChangePasswordFormValues>
          onFinish={onFinish}
          submitter={{
            searchConfig: {
              submitText: "Change Password",
            },
            resetButtonProps: {
              style: { display: "none" },
            },
          }}
        >
          <ProFormText.Password
            name="currentPassword"
            label="Current Password"
            placeholder="Enter your current password"
            rules={[
              { required: true, message: "Current password is required" },
            ]}
            fieldProps={{
              autoComplete: "current-password",
            }}
          />
          <ProFormText.Password
            name="newPassword"
            label="New Password"
            placeholder="Enter your new password"
            rules={[
              { required: true, message: "New password is required" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
            fieldProps={{
              autoComplete: "new-password",
            }}
          />
          <ProFormText.Password
            name="confirmPassword"
            label="Confirm New Password"
            placeholder="Confirm your new password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The passwords do not match")
                  );
                },
              }),
            ]}
            fieldProps={{
              autoComplete: "new-password",
            }}
          />
        </ProForm>
      </ProCard>
    </AntPageContainer>
  );
};
